import { render, staticRenderFns } from "./PanelWithStreamEditorGroup.vue?vue&type=template&id=45ffef82&lang=pug&"
import script from "./PanelWithStreamEditorGroup.vue?vue&type=script&lang=ts&"
export * from "./PanelWithStreamEditorGroup.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithStreamEditorGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports